import { CompactButton } from '@/components/buttons';
import { StandardButton } from '@/components/buttons/standard';
import { ContentPanel } from '@/components/content-panel';
import { CurbyAccordion } from '@/components/curby-accordion';
import { useCurrentUser } from '@/hooks';
import { PrimaryLayout } from '@/layouts/primary';
import { IconX } from '@tabler/icons-react';
import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { AccordionLocation } from '../../../../backend/src/types.generated';
import { useGetUserForHelpContentQuery } from './graphql.generated';

export const HelpPage = () => {
	const navigate = useNavigate();
	const { currentUser } = useCurrentUser();
	const { data } = useGetUserForHelpContentQuery({
		variables: { id: currentUser?.id ?? '' },
		skip: !currentUser?.id,
	});
	const closeButton = useMemo(
		() => (
			<CompactButton leftSection={<IconX />} onClick={() => navigate({ to: '/' })}>
				Close
			</CompactButton>
		),
		[navigate]
	);
	const reportAnIssueButton = useMemo(
		() => (
			<StandardButton onClick={() => navigate({ to: '/report-issue' })}>
				Report an Issue
			</StandardButton>
		),
		[navigate]
	);

	return (
		<PrimaryLayout
			header={{ title: 'Help', children: closeButton }}
			footer={{ children: reportAnIssueButton }}
		>
			<ContentPanel>
				<CurbyAccordion title="Our Mission" accordionLocation={AccordionLocation.HelpMission} />
				<CurbyAccordion
					title="Soft Plastics Program "
					accordionLocation={AccordionLocation.HelpMaterialsWeRecycle}
					council={data?.user?.council}
				/>
				<CurbyAccordion
					title="Other Materials"
					accordionLocation={AccordionLocation.HelpOtherMaterials}
				/>
				<CurbyAccordion
					title="Program Material"
					accordionLocation={AccordionLocation.HelpProgramMaterial}
				/>
				<CurbyAccordion title="Program" accordionLocation={AccordionLocation.HelpProgram} />
			</ContentPanel>
		</PrimaryLayout>
	);
};
